<template>
  <div id="fitbit-sleep-graph">
    <mu-paper>
      <fitbit-sleep-chart
        v-if="!isLoading && fitbitData.sleep.length > 0"
        :chart-data="data"
        :options="options">
      </fitbit-sleep-chart>
      <mu-card-text v-if="!isLoading && fitbitData.sleep.length === 0">
        <alert type="info" icon="info">
          <div slot="content">
            Not enough data to create a chart
          </div>
        </alert>
      </mu-card-text>
    </mu-paper>
  </div>
</template>
<script>

  
  
  import SleepApi from '../../../../api/Tracking/Sleep'
  import FitbitSleepChart from '../../../Tracking/Graph/FitBitSleep/index'
  import Alert from "../../../Alert/Alert.vue";

  const options = {

    responsive: true,
    maintainAspectRatio: false,
    bezierCurve: true,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 40
      }
    },
    tooltips: {
      mode: 'nearest',
      intersect: false
    },
    elements: {
      line: {
        tension: 0.5
      }
    },
    scales: {
      xAxes: [{
        gridLines: {
          display: false,
          color: '#738F9A',
          zeroLineColor: "transparent",
          borderDash: [1, 10],
          drawBorder: true
        },
        display: true,
        scaleLabel: {
          display: true,
        },
        time: {
          unit: 'minute',
          stepSize: 2,
          source: 'auto'
        },
        ticks: {
          autoSkip: true,
          autoSkipPadding: 60,
          maxRotation: 0,
          minRotation: 0
        }
      }],
      yAxes: [{
        gridLines: {
          display: true,
          color: '#738F9A',
          zeroLineColor: "transparent",
          borderDash: [1, 10],
          drawBorder: false
        },
        type: 'category',
        position: 'left',
        display: true,
        scaleLabel: {
          display: true
        }
      }]
    }
  };

  export default {
    name: "sleep-fitbit-graph",
    components: {
      FitbitSleepChart,
      Alert
    },
    props: {
      fitbitData: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isLoading: true,
        sleepData: {},
        data: {},
        options: options
      }
    },
    mounted() {
      let self = this;
      self.isLoading = true;
      let data = self.fitbitData.sleep[0];
      let graphData = {
        xLabels: [],
        datasets: []
      };

      if(self.fitbitData.sleep.length > 0) {
        self.sleepData = data;

        if(data.type === 'classic') {
          graphData.yLabels =  ['', 'Asleep', 'Awake', 'Restless', '']
        }

        if(data.type === 'stages') {
          graphData.yLabels = ['', 'Wake', 'REM', 'Light', 'Deep', '']
        }

        let levels = data.levels.data;
        let length = levels.length;
        let labels = [];
        let pointBackgrounds = [];
        let datasets = [];

        let dataset = {
          label: "Sleep",
          data: [],
          fill: false,
          borderWidth: 4,
          borderColor: '#17343A',
          pointBackgroundColor: ['transparent'],
          pointRadius: 0,
          steppedLine: true
        };


        for (let i = 0; i < length; i++) {
          pointBackgrounds.push();
          labels.push(moment(levels[i].dateTime).format('HH:mm a'));
          if(data.type === 'classic') {
            if (levels[i].level === 'asleep') {
              dataset.data.push('Asleep')
            }
            if (levels[i].level === 'awake') {
              dataset.data.push('Awake')
            }
            if (levels[i].level === 'restless') {
              dataset.data.push('Restless')
            }
          }
          if(data.type === 'stages') {
            if (levels[i].level === 'wake') {
              dataset.data.push('Wake')
            }
            if (levels[i].level === 'light') {
              dataset.data.push('Light')
            }
            if (levels[i].level === 'rem') {
              dataset.data.push('REM')
            }

            if (levels[i].level === 'deep') {
              dataset.data.push('Deep')
            }
          }
        }

        graphData.xLabels = labels;
        graphData.datasets = [dataset];

        self.data = graphData;
        self.$forceUpdate();

        self.isLoading = false;
      }
      else {
        self.isLoading = false;
      }
    },
    computed: {}


  }
</script>

<style lang="less">
  #fitbit-sleep-graph {
    .alert {
      display: block;
      max-width: 300px;
      margin: 120px auto;
    }
  }

</style>



// WEBPACK FOOTER //
// FitbitSteppedChart.vue?5842748b